import { lafayettePresentableUiPartNames, toSafeDisplayText, } from "./agent-ui-parts.js";
import { MESSAGE_ENVELOPE_LIMITS } from "./messaging.js";
// From a validated UI part to the part REFERENCE that travels in the Stream envelope (CHT-727; ADR 0014; contract section 3.5). The
// envelope holds the part name, its schema version and the canonical ids with a short label, never the part itself: the renderer reads
// the live entity by id. A part with no entity to point at (the run status) has no reference.
const presentable = new Set(lafayettePresentableUiPartNames);
const ref = (type, id, text) => ({
    type,
    id: id.toLowerCase(),
    label: toSafeDisplayText(text, MESSAGE_ENVELOPE_LIMITS.maxLabelChars),
});
function refsOf(part) {
    switch (part.name) {
        case "recommendation":
            return [ref("CATALOG_ITEM", part.data.entry.item.catalogItemId, part.data.entry.item.title)];
        case "recommendation-collection":
        case "comparison":
            return part.data.entries.map(({ item }) => ref("CATALOG_ITEM", item.catalogItemId, item.title));
        case "action-status":
            return [ref("CONCIERGE_REQUEST", part.data.entity.id, part.data.title)];
        case "concierge-request":
            return [ref("CONCIERGE_REQUEST", part.data.request.requestId, part.data.request.title)];
        case "handoff-status":
            return [ref("CONVERSATION", part.data.handoff.conversationId, null)];
        case "itinerary-preview": {
            const { itinerary } = part.data;
            const refs = [ref("ITINERARY", itinerary.itineraryId, itinerary.title)];
            if (itinerary.tripId !== null)
                refs.push(ref("TRIP", itinerary.tripId, null));
            return refs;
        }
        case "payment-request-placeholder":
            return [ref("PAYMENT_REQUEST", part.data.paymentRequestId, null)];
        case "run-status":
            return [];
    }
}
/**
 * The envelope reference of one part, or `null` when the part has none (the run status) or is not presentable. The version is the
 * schema version of the part. At most eight references per part (the envelope limit).
 */
export function messagePartRefOf(part) {
    if (!presentable.has(part.name))
        return null;
    const refs = refsOf(part).slice(0, MESSAGE_ENVELOPE_LIMITS.maxParts);
    if (refs.length === 0)
        return null;
    return { k: part.name, v: part.data.schemaVersion, refs };
}
